import React from 'react';

import { useTranslation } from './i18n';

export const DefaultDisplayUserError = () => {
  const { t } = useTranslation();
  return <>{t('NOT_AVAILABLE')}</>;
};
